import React, { useContext } from 'react'
import TimeTableContext from '../context/timeTableContext'

const MenuButton = () => {
  const context = useContext(TimeTableContext)
  

  return (
    <div class="open-close-menu" onClick={() => context.dispatch({ type: 'SET_NAV_DISPLAY', payload: true }) }><div></div><div></div><div></div></div>
  )
}

export default MenuButton
